<template>
  <div class="home">
    <div class="header">
      <v-carousel
        class="header-carousel"
        hide-delimiter-background
        show-arrows-on-hover
        height="auto"
      >
        <v-carousel-item v-for="(item, i) in sliders" :key="i">
          <img
            :src="require(`@/assets/images/rvs/${item}`)"
            alt="rv-image"
            class="header-image"
          />
        </v-carousel-item>
      </v-carousel>

      <div class="header-content">
        <v-container style="height: 100%">
          <div class="header-contain">
            <div class="header-search">
              <Search />
              <SearchMobile />
            </div>
          </div>
        </v-container>
      </div>
    </div>
  </div>
</template>

<script>
// import ReviewCard from "@/components/cards/ReviewCard.vue";
// import ServiceCard from "@/components/cards/ServiceCard.vue";
// import VanCard from "@/components/cards/VanCard.vue";
import SearchMobile from "@/components/search/SearchMobile.vue";
import Search from "@/components/search/Search.vue";
import { mapGetters } from "vuex";
import axios from "../modules/axios"
import store from "../store";

export default {
  components: { SearchMobile, Search },
  data: () => {
    return {
      users: [],
      services: [
        {
          title: "Deals for every budget",
          subtitle: "Incredible prices on all types RV in the worldwide",
          icon: "tag",
        },
        {
          title: "Best price guaranteed",
          subtitle:
            "Find a lower price? We’ll refund you 100% of the difference",
          icon: "wallet",
        },
        {
          title: "Top quality RV",
          subtitle:
            "Enjoy your RV Van’s comfortably of course with the best quality",
          icon: "cog",
        },
      ],
      rvs: [
        {
          title: "OVERLAND VAN PROJECT",
          image: "overland-1.png",
          slug: "overland-van-project",
          description:
            "As a child growing up with three sisters and hardworking parents with humble occupations, we never had the money to fly.",
        },
        {
          title: "SCOUT CAMPERS",
          image: "scout-1.png",
          slug: "scout-campers",
          description:
            "As a child growing up with three sisters and hardworking parents with humble occupations, we never had the money to fly.",
        },
        {
          title: "Mercedes Sprinter",
          image: "sprinter-1.png",
          slug: "mercedes-sprinter",
          description:
            "As a child growing up with three sisters and hardworking parents with humble occupations, we never had the money to fly.",
        },
      ],
      reviews: [
        {
          name: "John Doe",
          rating: 5,
          address: "123 Main Portland",
          review:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        },
        {
          name: "John Miller",
          rating: 4,
          address: "123 Main Portland",
          review:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        },
        {
          name: "John David",
          rating: 4.5,
          address: "123 Main Portland",
          review:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        },
        {
          name: "John Walker",
          rating: 4.5,
          address: "123 Main Portland",
          review:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
        },
      ],
      sliders: [
        // "1.jpg",
        // "2.jpg",
        "3.jpg",
        // "4.jpg",
        // "5.jpg",
      ],
    };
  },
  name: "DefaultPage",
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    isMember() {
      return this.user?.member;
    },
  },
  mounted() {
    this.getCredits();
  },
  methods: {
    async getCredits() {
      try {
        const response = await axios.get("credit");
        if (response.data) {
          const userData = {
            ...this.user,
            credit_days: response.data.credit,
            included_miles: response.data.miles,
          };

          store.dispatch({
            type: "updateUser",
            user: userData,
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
<style scoped lang="scss">
.header {
  position: relative;
  // height: 100vh;
  min-height: 55vh;

  &-carousel {
    // margin-bottom: -150px;
    margin-top: -80px;
    // height: 70vh;
    // position: absolute;
    // top: 0;
    // left: 0;
    // height: 100%;
    // width: 100%;
    // width: 100%;
  }

  &-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 10px;
    background: rgba(0, 0, 0, 0.5);
  }
  &-headings {
    // background: rgba(0, 0, 0, 0.2);
    max-width: 100%;
    border-radius: 16px;
    // border: 1px solid var(--light1);
    // padding: 10px 25px;
    // backdrop-filter: blur(2px);
    // margin-top: 40px;
    margin-bottom: 10%;
  }
  &-contain {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 75vh;
    // padding-top: 200px;
  }
  &-image {
    width: 100%;
    // height: 80vh;
    object-fit: cover;
    position: relative;
  }
  &-content {
    position: absolute;
    bottom: 58%;
    left: 50%;
    // right: 0;
    // top: 0;
    // z-index: 5;
  }
  &-text {
    // font-weight: bold;
    font-size: 50px;
    font-weight: 400;
    color: var(--light);
    letter-spacing: 4px;
  }
  &-subtitle {
    font-size: 20px;
    font-weight: bold;
    color: var(--light);
    letter-spacing: 4px;
  }
  &-overlap {
    width: 100%;
    height: 100px;
    background-color: var(--primary-color);
  }
  &-search {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    display: flex;
    justify-content: center;
    margin-bottom: 25px;
  }
}
.service {
  position: relative;
  background: #f2f2f2; //rgba(110, 114, 2, 0.15);
  padding-bottom: 35px !important;
  padding-top: 80px;

  &-image {
    width: 100%;
  }
  &-ringleft {
    position: absolute;
    left: -60px;
    top: -60px;
  }
  &-ringright {
    position: absolute;
    right: -100px;
    bottom: -60px;
  }
  &-ring-img {
    width: 200px;
  }
}
.testimonial {
  position: relative;
  background: rgba(111, 115, 3, 0.15);
  padding: 25px 0;
  padding-bottom: 30px;
}
.vehicles {
  background: url("../assets/images/vehicle-bg.png") no-repeat center;
  // height: 600px;
  min-height: 650px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}
.contact {
  // background: url('../assets/images/contact-bg.png') no-repeat center;
  min-height: 300px;
}

@media screen and (max-width: 800px) {
  .header {
    &-image {
      width: 100%;
      height: 55vh;
      object-fit: cover;
      position: relative;
    }
    &-carousel {
      // height: 55vh;
    }
    &-content {
      position: absolute;
      bottom: 38%;
      left: 50%;
    }
  }
}
</style>
